import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { SignupPage } from './pages/signup-page/signup-page';
import { PasswordPage } from './pages/login/components/password-page/password-page';
import { ResetPassword } from './pages/login/components/reset-password/reset-password';
import { ResetVerify } from './pages/reset-verify/reset-verify';
export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    children: [
      { path: '', component: Login },
      { path: 'password', component: PasswordPage },
      { path: 'reset-password', component: ResetPassword },
    ]
  },
  { path: 'reset-verify', component: ResetVerify },
  {
    path: 'signup', component: SignupPage
  },
];
